<form [formGroup]="contactMessageForm" (ngSubmit)="submitMessage()" class="contact-message-form" novalidate>
  <div class="contact-message-form__card">
    <h3 class="contact-message-form__title"><strong>Got a question? Send us a message.</strong></h3>
    <p class="contact-message-form__qa-link">
      <a href="/q-and-a">(Read our Q &amp; A for answers to most commonly asked questions)</a>
    </p>
    <div class="contact-message-form__grid two-col">
      <label>
        <span>Name</span>
        <input type="text" formControlName="name" />
      </label>

      <label>
        <span>Email</span>
        <input type="email" formControlName="email" />
      </label>
    </div>

    <label class="contact-message-form__message-label">
      <span>Your message:</span>
      <textarea formControlName="message" rows="5" spellcheck="true"></textarea>
    </label>

    <div class="contact-message-form__honeypot" aria-hidden="true">
      <label>
        <span>Website</span>
        <input type="text" formControlName="honeypotWebsite" tabindex="-1" autocomplete="new-password" />
      </label>

      <label>
        <span>Reference</span>
        <input type="text" formControlName="honeypotReference" tabindex="-1" autocomplete="new-password" />
      </label>
    </div>

    @if (submitError) {
    <p class="contact-message-form__error">{{ submitError }}</p>
    }

    @if (submittedMessage) {
    <p class="contact-message-form__success">{{ submittedMessage }}</p>
    }

    <div class="contact-message-form__actions">
      <button type="submit" [disabled]="contactMessageForm.invalid || submitting" class="contact-message-form__submit">
        {{ submitting ? 'Submitting...' : 'Submit' }}
      </button>
    </div>
  </div>
</form>
